import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class EntrySummarySynchronizationRepository {
  constructor(private apiService: ApiService) {}

  public data(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.prefixCustoms}v2/management/entry-summaries/${id}/sync/data`);
  }

  public cbpForm7501(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.prefixCustoms}v2/management/entry-summaries/${id}/sync/7501`);
  }

  public cargoReleaseForm3461(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.prefixCustoms}v2/management/entry-summaries/${id}/sync/3461`);
  }

  public cargoReleaseFile(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.prefixCustoms}v2/management/entry-summaries/${id}/sync/cargo-release-file`);
  }

  public duties(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.prefixCustoms}v2/management/entry-summaries/${id}/sync/duties`);
  }

  public providerConnection(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.prefixCustoms}v2/management/entry-summaries/${id}/sync/provider-connection`);
  }
}
